export enum FilterOperatorEnum {
  EQUALS = 'EQUALS',
  EQ = 'EQ',
  NOT_EQ = 'NOT_EQ',
  CONTAINS = 'CONTAINS',
  NOT_CONTAINS = 'NOT_CONTAINS',
  EMPTY = 'EMPTY'
};
